import MicroModal from "micromodal";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteListCallQueue, ActionDeleteCall } from "../../actions";
import { ReactComponent as IconClose } from "../../build/images/closecircle22px.svg";
import Slider from "@mui/material/Slider";

const marks = [
  {
    value: 0,
    label: "0%",
  },
  {
    value: 100,
    label: "100%",
  },
];

export default function MetaValueModalV2({
  setValue,
  value,
  setMetaValue,
  handleMetaValue,
  storageKey = "meta_manager_perfomance",
  text = "Digite ou selecione a meta",
}) {
  const handleMeta = () => {
    localStorage.setItem(storageKey, value);
    handleMetaValue();
  };

  const handleSliderChange = (event, newValue) => {
    //localStorage.setItem(storageKey, newValue);
    setValue(newValue);
  };

  const closeModal = () => {
    //setMetaValue(value);
    MicroModal.close("modal__edit_meta_value");
  };

  return (
    <div
      className="modal micromodal-slide"
      id="modal__edit_meta_value"
      aria-hidden="true"
      role="dialog"
    >
      <div className="modal__overlay" tabIndex="-1">
        <div
          className="modal__container"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__bloqueio__title"
        >
          <div className="modal__meta-header">
            <span className="modal__meta-title">Editar a Meta</span>
            <div
              onClick={() => closeModal()}
              className="modal__meta-button-close"
            >
              <IconClose />
            </div>
          </div>
          <div className="modal__meta-slider_body">
            <span className="modal__meta-slider_body-text">{text}</span>
            <span className="modal__meta-slider_body-value">{value}</span>
            <Slider
              aria-label="SLA"
              valueLabelDisplay="auto"
              value={value}
              onChange={handleSliderChange}
              marks={marks}
            />
            <div className="modal__meta-slider_body__buttons">
              <div
                className="modal__meta-slider_body__buttons__cancel"
                onClick={() => closeModal()}
              >
                Cancelar
              </div>
              <div
                className="modal__meta-slider_body__buttons__save"
                onClick={handleMeta}
              >
                Salvar
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
